import { AssetType } from '@vimond/services/content-discovery';
import { cn } from '@vimond/theme/tailwind';
import { getEnvVar } from '@vimond/utils/env';
import { usePathname } from 'next/navigation';
import { PlaylistItem } from './PlaylistItem';

type Props = {
  assets: AssetType[];
  currentlyPlayingId: string | undefined;
  isHidden: boolean;
  onClick?: (id: string) => void;
};

export const PlaylistItems = ({
  assets,
  currentlyPlayingId,
  isHidden,
  onClick,
}: Props) => {
  const fullScreenWatchLayout =
    usePathname()?.includes('/watch') &&
    !(getEnvVar('NEXT_PUBLIC_ALTERNATIVE_WATCH_LAYOUT') === 'true');

  return (
    <div
      className={cn(
        'right-2 transition-opacity',
        fullScreenWatchLayout
          ? 'absolute bottom-24 top-16 overflow-y-auto'
          : 'w-full px-3 my-4 lg:max-h-[100%] lg:h-auto lg:top-0 lg:right-3 lg:bottom-0 lg:w-[33vw]',
        fullScreenWatchLayout && isHidden ? 'opacity-0' : 'opacity-100',
      )}
    >
      <div
        className={`lg:overflow-y-hidden lg:hover:overflow-y-auto overflow-x-hidden ${
          fullScreenWatchLayout
            ? 'hidden flex-col gap-1 sm:flex'
            : 'grid gap-2 xs-sm:grid-cols-2 md-only:grid-cols-3 lg:shadow-xl lg:h-full lg:max-h-[95vh] lg:flex lg:flex-col'
        }`}
      >
        {assets?.map((asset, index) => {
          return (
            <PlaylistItem
              key={`asset-${index}-${asset.id}`}
              asset={asset}
              showInPosterMode={fullScreenWatchLayout}
              active={asset.id === currentlyPlayingId}
              onClick={() => {
                onClick?.(asset.id);
              }}
            />
          );
        })}
      </div>
    </div>
  );
};
